module.exports = __webpack_public_path__ + "img/head-icon.127e92b5.png";